import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserRulesService } from 'src/app/shared/services/user-rules.service';
import { LoginFormService } from '../login-form/login-form.service';
import { SearchObjectService } from 'src/app/shared/services/search-object.service';
import { LoadingScreenService } from 'src/app/shared/components/loading-screen/loading-screen.service';

@Component({
  selector: 'app-findpcp',
  templateUrl: './findpcp.component.html',
  styleUrls: ['./findpcp.component.scss']
})
export class FindPCPComponent implements OnInit {
  page: string;
  type: string;
  providerName: string;
  providerPhoneNumber: string;
  providerErrorMsg: string;
  isPCPSearch = false;
  isErrorCode: any;
  loadComplete = false;
  error: any = {
    providerErrorMsg: ''
  };
  queryParamMap;

  @Input() clickedSearchCriteria;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private userRulesService: UserRulesService,
    private loginFormService: LoginFormService,
    private searchObjectService: SearchObjectService,
    private loadingScreenService: LoadingScreenService) {
    this.page = this.router.parseUrl(router.url).root.children['primary'].segments.map(it => it.path).join('/');
  }

  ngOnInit() {
    this.loadingScreenService.toggleLoaderOn();
    this.queryParamMap = null;
    if(this.activatedRoute.snapshot.queryParamMap.keys.length > 0) {
      this.queryParamMap = this.activatedRoute.snapshot.queryParamMap;
      if(this.queryParamMap) {
        if(this.queryParamMap.get('membercardid')) {
          this.searchObjectService.removeQueryParams('membercardid');
        }
        if(this.queryParamMap.get('memberid')) {
          this.searchObjectService.removeQueryParams('memberid');
        }
      }
    }

    this.userRulesService.checkLogin(true).subscribe(loggedIn => {
      if(loggedIn) {
        this.isPCPSearch = this.userRulesService.isUserPCP();
        let primaryId = this.userRulesService.getPrimaryId();
        this.getMemberDetails(primaryId);
        this.getPCPName(primaryId);
        this.getMemberNetwork(this.userRulesService.getSecondaryId(), this.userRulesService.getTPAClientIdentifier());
      } else {
        this.loadComplete = true;
        this.loadingScreenService.toggleLoaderOff();
      }
    });
  }

  private getMemberNetwork(id: string, tpaClientIdentifier?: string) {
    this.loginFormService.getMemberNetwork(id, tpaClientIdentifier).subscribe(data => {
      if(data && data.networks && data.networks.length !== 0) {
        this.searchObjectService.setLoggedIn(true);
        this.searchObjectService.setCareTypes(data.networks);
      }
      this.loadComplete = true;
      this.loadingScreenService.toggleLoaderOff();
    },
      error => {
        this.loadComplete = true;
        this.loadingScreenService.toggleLoaderOff();
      });
  }

  private getPCPName(id: string) {
    this.error.providerErrorMsg = '';
    this.loginFormService.getPCPName(id).subscribe(data => {
      data = data.currentPcp ? data.currentPcp : null;
      if(!data) {
        this.providerErrorMsg = 'No PCP selected';
      } else {
        this.providerName = (data && data.providerName ? data.providerName : '');
        this.searchObjectService.setPcpData(data);
        if(data && data.officeName) {
          if(this.providerName) {
            this.providerName += ', ';
          }
          this.providerName += data.officeName;
        }
        this.providerPhoneNumber = (data && data.officePhoneNumber ? data.officePhoneNumber : '');
      }
    },
      error => {
        this.isErrorCode = error.status;
        this.providerErrorMsg = (this.isErrorCode === 404 || this.isErrorCode === 204) ? 'No PCP selected' : 'An unexpected error occurred, please try your search again later.';
      });
  }

  private getMemberDetails(memberId: string) {
    this.loginFormService.getMemberDetails(memberId).subscribe(data => {
      this.searchObjectService.setMemberData(data);
    });
  }
}